import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {FaDiscord} from 'react-icons/fa'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/iyanu-oluwadamilare-a81314229" target="_blank"><BsLinkedin/></a>
        <a href="https://github.com/iyanuxn" target="_blank"><FaGithub/></a>
        <a href="https://discordapp.com/users/755428319213912105" target="_blank"><FaDiscord/></a>      
    </div>
  )
}

export default HeaderSocials
